/* tslint:disable */
/* eslint-disable */
/**
 * Private UI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: ${project.version}
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DeviceTypeEtcResponse
 */
export interface DeviceTypeEtcResponse {
    /**
     * 
     * @type {boolean}
     * @memberof DeviceTypeEtcResponse
     */
    enableStbAuth: boolean | null;
}

export function DeviceTypeEtcResponseFromJSON(json: any): DeviceTypeEtcResponse {
    return DeviceTypeEtcResponseFromJSONTyped(json, false);
}

export function DeviceTypeEtcResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeviceTypeEtcResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'enableStbAuth': json['enableStbAuth'],
    };
}

export function DeviceTypeEtcResponseToJSON(value?: DeviceTypeEtcResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'enableStbAuth': value.enableStbAuth,
    };
}

